import { Typography, Separator, Button, Form } from '@ui/components';
import { useTranslation } from 'react-i18next';
import { Loading } from '@ui/components';
import { FC } from 'react';

import {
  TopUpPayUAgreements,
  TopUpWireTransfer,
  TopUpPayment,
  TopUpAmount,
} from '../../containers/onboarding-top-up-balance';
import { useOnboardingTopUp } from './use-onboarding-top-up';

export const OnboardingTopUpBalance: FC = () => {
  const { t } = useTranslation();

  const {
    setWireTransferChecked,
    onSubmitWireTransfer,
    wireTransferChecked,
    isLoading,
    isPending,
    onSubmit,
    payURef,
    payUID,
    data,
    form,
  } = useOnboardingTopUp();

  if (isLoading) {
    return <Loading />;
  }

  return (
    <form className="space-y-8" onSubmit={onSubmit}>
      <Typography variant="h400" element="h1">
        {t('ONBOARDING.TOP_UP.TITLE')}
      </Typography>

      <div className="space-y-8">
        <Form {...form}>
          <TopUpAmount
            suggestedTopUpAmount={data?.suggestedTopUpAmount}
            formControl={form.control}
          />
          {!wireTransferChecked && payUID && (
            <TopUpPayment
              disabled={wireTransferChecked}
              formControl={form.control}
              payURef={payURef}
              payUID={payUID}
            />
          )}
        </Form>
        <TopUpWireTransfer
          costCenterAccountNumber={data?.costCenterAccountNumber}
          onCheckedChange={setWireTransferChecked}
          checked={wireTransferChecked}
        />
      </div>

      <div className="space-y-8">
        <Separator />
        {wireTransferChecked ? (
          <Button
            onClick={onSubmitWireTransfer}
            isLoading={isPending}
            disabled={isPending}
            type="button"
            size="large"
            wide
          >
            {t('ONBOARDING.TOP_UP.CONTINUE')}
          </Button>
        ) : (
          <Button isLoading={isPending} disabled={isPending} type="submit" size="large" wide>
            {t('ONBOARDING.TOP_UP.CONTINUE')}
          </Button>
        )}

        {!wireTransferChecked && <TopUpPayUAgreements />}
      </div>
    </form>
  );
};
